import React from 'react';
import { Paper, Box, Typography, Grid } from '@material-ui/core';
import VipCardStyled from './vipCardStyles';

export default ({ data, list, formatMessage }) => {
  return (
    <VipCardStyled>
      <Paper sx={{ padding: '16px 24px 31px', borderRadius: '4px' }}>
        <Box className="detail-title">
          {formatMessage({ id: 'order.order.detail.n01.lbl01' })}
        </Box>
        <Grid container spacing={2} sx={{ gap: '34px 0' }}>
          {list.map((item, index) => (
            <Grid item xs={3} key={`vip${index}`} sx={{ paddingTop: 0 }}>
              <Box display="flex" flexDirection="column">
                <Typography className="detail-label">{item.label}</Typography>
                <Typography className="detail-info">
                  {data && data[item.id] ? data[item.id] : ''}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Paper>
    </VipCardStyled>
  );
};
